import CityPageTemplate from "../city-template/CityPageTemplate";
import { newportBeachConfig } from "./data";

export default function NewportBeachPage() {
  return <CityPageTemplate config={newportBeachConfig} />;
}